
import { BehaviorSubject } from 'rxjs';let awbNext = false;
let awbValue = '';
let turn_id = '';
let turn_counter_checkouts_id	= '';

const disabledBtnTurn$ = new BehaviorSubject(false);
export const getDisabledBtnTurn = () => disabledBtnTurn$.asObservable();
export const setDisabledBtnTurn = (value) => disabledBtnTurn$.next(value);


const idArrDisabled$ = new BehaviorSubject([]);
export const getIdArrDisabled = () => idArrDisabled$.asObservable();

export const setValidateAwb = (value) => {
  awbValue = value;
  if(awbValue === "" || awbValue ==="139-") {
    awbNext = false;
  } else {
    awbNext = true;
  }
}

export const validateAwb = async () => {
  if(!awbNext) {
    if(awbValue === "" || awbValue ==="139-")
      return {status: false, message:'Todos los embarques deben tener un número de guía antes de continuar.'}
  }

  return {status: true, message: "Coninue with the validation"}
}

export const setTurnId = (id) => {
  turn_id = id;
} 

export const getTurnId = async () => {
  return turn_id;
};

export const setTurnCounterCheckoutId = (id) => {
  turn_counter_checkouts_id = id;
} 

export const getTurnCounterCheckoutId = async () => {
  return turn_counter_checkouts_id;
};

export const addIdArrDisabled = (id) => {
  const current = idArrDisabled$.value;
  if (!current.includes(id)) {
    idArrDisabled$.next([...current, id]);
  }
};

export const finishTurnAlert = async (data) => {
  const allDisabled = data.every(item => idArrDisabled$.value.includes(item.id));
  return allDisabled;
}

export const resetTurnState = () => {
  disabledBtnTurn$.next(false); // habilitar botón
  idArrDisabled$.next([]);      // limpiar lista de ids
  awbNext = false;
  awbValue = '';
  turn_id = '';
};